// extracted by mini-css-extract-plugin
module.exports = {"notificationCountButtonContainer":"ViewEquipmentSentinels_notificationCountButtonContainer__yxQbo","messageContainer":"ViewEquipmentSentinels_messageContainer__1Krau"};